import { useState } from 'react';
import { toast } from 'react-toastify';

const MAX_FILE_SIZE = 5 * 1024 * 1024; // 5MB in bytes

export const useImageUpload = (onImagesChange) => {
  const [dragActive, setDragActive] = useState(false);
  const [draggedIndex, setDraggedIndex] = useState(null);

  const processFiles = (files) => {
    Array.from(files).forEach((file) => {
      const validImageTypes = ['image/jpeg', 'image/png'];
      
      if (!validImageTypes.includes(file.type)) {
        toast.error('Only JPG and PNG images are allowed');
        return;
      }

      if (file.size > MAX_FILE_SIZE) {
        toast.error(`Image "${file.name}" exceeds 5MB limit`);
        return;
      }

      onImagesChange((prev) => [...prev, file]);
    });
  };

  const handleImageInput = (e) => {
    if (e.target.files) {
      processFiles(e.target.files);
    }
  };

  const handleDrag = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (e.type === 'dragenter' || e.type === 'dragover') {
      setDragActive(true);
    } else if (e.type === 'dragleave') {
      setDragActive(false);
    }
  };

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setDragActive(false);
    if (e.dataTransfer.files) {
      processFiles(e.dataTransfer.files);
    }
  };

  const removeImage = (index) => {
    onImagesChange((prev) => prev.filter((_, i) => i !== index));
  };

  const moveImage = (fromIndex, toIndex) => {
    onImagesChange((prev) => {
      const newImages = [...prev];
      const [movedImage] = newImages.splice(fromIndex, 1);
      newImages.splice(toIndex, 0, movedImage);
      return newImages;
    });
  };

  const handleImageDragStart = (index) => {
    setDraggedIndex(index);
  };

  const handleImageDragOver = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  const handleImageDrop = (toIndex) => {
    if (draggedIndex !== null && draggedIndex !== toIndex) {
      moveImage(draggedIndex, toIndex);
    }
    setDraggedIndex(null);
  };

  return {
    dragActive,
    handleImageInput,
    handleDrag,
    handleDrop,
    removeImage,
    moveImage,
    draggedIndex,
    handleImageDragStart,
    handleImageDragOver,
    handleImageDrop,
  };
};
